import api from '@/api';
import {
  WorkOrderPecaAiBasketDetailRequest,
  WorkOrderPecaAiBasketDetail,
  WorkOrderPecaAiBasketSummary,
  WorkOrderPecaAiOrderDetailRequest,
  WorkOrderPecaAiOrderDetailResponse,
  WorkOrderPecaAiSearchProductRequest,
  WorkOrderPecaAiSearchProductResponse,
  WorkOrderPecaAiRemoveProductInBasketRequest,
  WorkOrderPecaAiAddProductInBasketRequest,
} from './workorder-pecaAi.types';

const path = '/workorder/v1/peca-ai';

export default {
  async hasBuyer(cnpj: string) {
    const result = (await api.get(
      `${path}/buyers/cnpj/${cnpj}`,
      {},
    )) as unknown;

    return result as void;
  },

  async basketSummary(params: WorkOrderPecaAiBasketDetailRequest) {
    const result = (await api.get(
      `${path}/buyers/${params.document}/baskets/${params.basketId}/summary`,
      {},
    )) as unknown;

    return result as WorkOrderPecaAiBasketSummary;
  },

  async detailBasket(params: WorkOrderPecaAiBasketDetailRequest) {
    const result = (await api.get(
      `${path}/buyers/${params.document}/baskets/${params.basketId}`,
      {},
    )) as unknown;

    return result as WorkOrderPecaAiBasketDetail;
  },

  async detailOrder(params: WorkOrderPecaAiOrderDetailRequest) {
    const result = (await api.get(
      `${path}/buyers/${params.document}/orders/${params.orderId}`,
      {},
    )) as unknown;

    return result as WorkOrderPecaAiOrderDetailResponse;
  },

  async verifyToken() {
    const result = (await api.get(`${path}/verify-token`, {})) as unknown;

    return result as void;
  },

  async searchProduct(data: WorkOrderPecaAiSearchProductRequest) {
    const result = (await api.post(`${path}/products/search`, data)) as unknown;

    return result as WorkOrderPecaAiSearchProductResponse;
  },

  async removeProductInBasket(
    params: WorkOrderPecaAiRemoveProductInBasketRequest,
  ) {
    const result = (await api.remove(
      `${path}/buyers/${params.document}/baskets/${params.basketId}/products/${params.productId}`,
      {},
      null,
    )) as unknown;

    return result as void;
  },

  async addProductInBasket({
    document,
    basketId,
    ...data
  }: WorkOrderPecaAiAddProductInBasketRequest) {
    const result = (await api.post(
      `${path}/buyers/${document}/baskets/${basketId}/products`,
      data,
    )) as unknown;

    return result as void;
  },
};
